import styles from './PrincipleBlock.module.css';

interface PrincipleBlockProps {
  body: string;
  number: string;
  title: string;
}

export function PrincipleBlock({ body, number, title }: PrincipleBlockProps) {
  return (
    <article className={styles.block}>
      <span aria-hidden="true" className={styles.number}>
        {number}
      </span>
      <div className={styles.copy}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.body}>{body}</p>
      </div>
    </article>
  );
}
